import angular from 'angular'

import 'angular-socialshare/dist/angular-socialshare.js'

import ggsUtils from '../utils'
import ggsIcons from '../ggs-icons'
import ggsAnimate from '../ggs-animate'
import ggsHaltClick from '../ggs-halt-click'
import ggsRecalcOnevent from '../ggs-recalc-onevent'
import ggsGalleryCodeWizard from '../gallery-code-wizard'

const ngSocialShare = '720kb.socialshare'

export default angular
  .module('ggs.gallery-sharing', [
    ngSocialShare,
    ggsUtils,
    ggsIcons,
    ggsAnimate,
    ggsHaltClick,
    ggsRecalcOnevent,
    ggsGalleryCodeWizard
  ])
  .name
